import React, { useContext, useEffect, useState } from "react";
import LayoutNew from "../components/shared/LayoutNew";
import { Form, Button, InputGroup, ButtonGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { isEmpty } from "lodash";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { apiGet, apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { toast } from "react-toastify";
import moment from "moment";
import AuthContext from "../context/AuthContext";
import { BiSolidDownArrow, BiSolidUpArrow } from "react-icons/bi";
const Promotions = () => {
  const {
    formState: { errors },
  } = useForm({});
  const { profileData } = useContext(AuthContext);
  const getFilteredOfferList = (count, list) => {
    const depositKeys = [
      "OnFirstDeposit",
      "OnSecondDeposit",
      "OnThirdDeposit",
      "OneFourthDeposit",
    ];

    // If count = 0 → show only OnFirstDeposit
    // if (count === 0) {
    //   return list.filter((offer) => offer.offerOn === depositKeys[0]);
    // }

    // Otherwise, remove first `count` deposit offers
    // const keysToRemove = depositKeys.slice(0, count);
    // return list.filter((offer) => !keysToRemove.includes(offer.offerOn));
    return list.filter((offer) => offer.offerOn);
  };

  const [data, setData] = useState([]);
  const getData = async () => {
    const { status, data } = await apiGet(apiPath.getPromotional);
    if (status == 200) {
      if (data?.success) {
        setData(
          getFilteredOfferList(
            profileData?.userDepositCount,
            data?.results?.offerList
          )
        );
      }
    }
  };
  const navigate = useNavigate();
  useEffect(() => {
    getData();
  }, [profileData]);
  function getTimeDifferenceString(currentTime, endTime) {
    const now = moment(currentTime);
    const end = moment(endTime);

    if (end.isBefore(now)) {
      return "Ended";
    }

    const duration = moment.duration(end.diff(now));
    const days = Math.floor(duration.asDays());
    const hours = duration.hours();

    return `End in ${days} days ${hours} hours`;
  }
  const [active, setActive] = useState("");

  return (
    <LayoutNew>
      <div className="activity-preview-bg">
        <div className="page-title">
          <span>Promotion</span>
        </div>
        <div className="activity-content">
          <div className="promo-list">
            {data?.map((res) => {
              return (
                <div className="promo-item">
                  <div className="corner-icons">
                    <div className="corner top-left"></div>
                    <div className="corner top-right"></div>
                    <div className="corner bottom-left"></div>
                    <div className="corner bottom-right"></div>
                    <div className="promo-item-bg">
                      <div className="activity-img">
                        <img
                          src={`${import.meta.env.VITE_API_BASE_URL}${res?.offerImage}`}
                          alt="Dreamer Recruitment Program"
                        />
                      </div>
                      <div className="activity-info">
                        <div className="title">
                          <span>{res?.title}</span>
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {/* <div
                            onClick={() => navigate(`/deposit/${res?._id}`)}
                            className="view-all"
                            style={{ marginRight: "5px" }}
                          >
                            Deposit
                          </div> */}
                          {active == res?._id ? (
                            <BiSolidUpArrow
                              onClick={() => setActive("")}
                              size={20}
                              color="#23ffc8"
                            />
                          ) : (
                            <BiSolidDownArrow
                              onClick={() => setActive(res?._id)}
                              size={20}
                              color="#23ffc8"
                            />
                          )}
                        </div>
                      </div>
                      {active == res?._id && (
                        <div className="offer-content">
                          <span>
                            Offer End -{" "}
                            <span style={{ fontWeight: "600" }}>
                              {getTimeDifferenceString(
                                new Date(),
                                res?.offerEndDateTime
                              )}
                            </span>
                          </span>{" "}
                          <span>
                            Offer Time -{" "}
                            <span style={{ fontWeight: "600" }}>
                              {moment(res?.offerStartDateTime).format(
                                "MMMM Do YYYY, h:mm:ss a"
                              )}{" "}
                              -{" "}
                              {moment(res?.offerEndDateTime).format(
                                "MMMM Do YYYY, h:mm:ss a"
                              )}
                            </span>
                          </span>
                          <span> {res?.description}</span>
                          <span
                            style={{
                              display: "flex",
                              alignItems: "start",
                              // justifyContent: "center",
                              width: "100%",
                              margin: "5px 0",
                            }}
                          >
                            <img
                              src={`${import.meta.env.VITE_API_BASE_URL}${res?.descriptionImage}`}
                              alt="Dreamer Recruitment Program"
                            />{" "}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </LayoutNew>
  );
};

export default Promotions;
